<div class="day-selector-container">
  <mat-card class="day-selector-card" [class.weekend]="getCurrentDayInfo().isWeekend">
    <div class="selector-header">
      <div class="day-info">
        <mat-icon class="day-icon">{{ getCurrentDayInfo().isWeekend ? 'weekend' : 'today' }}</mat-icon>
        <div class="day-details">
          <h3 class="day-date">{{ formatDate(getCurrentDayInfo().date) }}</h3>
          <p class="day-name">{{ getCurrentDayInfo().dayName }}</p>
        </div>
      </div>

      <div class="controls-column">
        <div class="day-controls">
          <button mat-icon-button aria-label="Előző nap" [disabled]="currentDay <= 1" (click)="goToPreviousDay()">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button mat-stroked-button [disabled]="isToday()" (click)="goToToday()">Ma</button>
          <button mat-icon-button aria-label="Következő nap" [disabled]="currentDay >= maxDays" (click)="goToNextDay()">
            <mat-icon>chevron_right</mat-icon>
          </button>

          <mat-form-field appearance="outline" class="year-field" subscriptSizing="dynamic">
            <mat-label>Év</mat-label>
            <mat-select [value]="selectedYear" (valueChange)="onYearChange($event)">
              @for (year of availableYears; track year) {
                <mat-option [value]="year">{{ year }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <button mat-icon-button
                type="button"
                class="export-button"
                [disabled]="exportDisabled || isExporting"
                matTooltip="Exportálás XLSX-be"
                aria-label="Exportálás XLSX-be"
                (click)="onExportClick()">
          <mat-icon>download</mat-icon>
        </button>
      </div>
    </div>

    <div class="slider-container">
      <mat-slider
        [min]="1"
        [max]="maxDays"
        [step]="1"
        [discrete]="true"
        [displayWith]="sliderLabel"
        class="day-slider">
        <input matSliderThumb [value]="currentDay" (input)="onSliderInput($event)">
      </mat-slider>
    </div>
  </mat-card>
</div>
